import { Action } from '@ngrx/store';

export enum FailureModalActionTypes {
  CloseFailureModal = '[FailureModal] Close',
}

export class CloseFailureModal implements Action {
  readonly type = FailureModalActionTypes.CloseFailureModal;
}

export type FailureModalActions = CloseFailureModal;
